import DiscussionFilterProvider from './DiscussionFilterProvider';

export default DiscussionFilterProvider;
